<div
  cdkDragBoundary=".restricted"
  #cdkDrag
  cdkDrag
  class="example-box"
  [cdkDragFreeDragPosition]="position()"
>
  <ng-content></ng-content>
</div>
